import { LoadableAfterPaint } from '@confluence/loadable';

export const CompanyHubBannerLoader = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-CompanyHubBanner" */ './CompanyHubBanner'))
			.CompanyHubBanner,
});
